import React from 'react'
import { createImageUrl } from 'utils/imageUtilities'
import { localized, withDialogs, dialogTypes } from 'decorators'
import { Button } from 'components/buttons'
import { useStyles } from './index.css'

const ImageItem = ({ id, onImageRemove, classes, localize, showDialog, disabled }) => {
  const handleRemove = React.useCallback(() => { onImageRemove(id) }, [id, onImageRemove])
  const handleShowDetail = React.useCallback(() => {
    showDialog({
      dialogType: dialogTypes.imageDetail,
      context: {
        id
      }
    })
  }, [id, showDialog])
  return (
    <div className={classes.item}>
      <img
        className={classes.image}
        src={createImageUrl(id)}
        onClick={handleShowDetail}
        alt={''}
        />
      {!disabled && <Button
        className={classes.remove}
        color='secondary'
        title={localize('wines.removeImageTooltip')}
        width={32}
        onClick={handleRemove}
        icon='times'></Button>}
    </div>
  )
}
export const Images = withDialogs(localized(({ imageIds = [], onImageRemove, localize, showDialog, disabled }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {imageIds.map((x, idx) => <ImageItem key={idx} id={x} disabled={disabled} localize={localize} showDialog={showDialog} onImageRemove={onImageRemove} classes={classes} />)}
    </div>
  )
}))